module.exports = __webpack_public_path__ + "static/img/ZRS2768_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ZRS2768_1.png
// module id = kmLb
// module chunks = 0